import { render, staticRenderFns } from "./AddReserve.vue?vue&type=template&id=389cb0ce&scoped=true"
import script from "./AddReserve.vue?vue&type=script&lang=js"
export * from "./AddReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389cb0ce",
  null
  
)

export default component.exports